/**
 * FogOfWarSettingsContainer - Container Component
 *
 * Container component responsible for:
 * - Zustand store connection (useStore, useActions)
 * - Delegating presentation to the pure FogOfWarSettings component
 *
 * This follows the Container/Presenter pattern as defined in ADR-034.
 * @see docs/adr/0034-container-presenter-component-pattern.md
 */

import React from 'react';
import { useStore, useActions } from '../../hooks/useStore';
import { useStableCallback } from '../../hooks/hookUtils';
import FogOfWarSettings from './FogOfWarSettings';

export function FogOfWarSettingsContainer(): React.ReactElement {
  const fogSettings = useStore(state => state.settings.fogOfWar || { enabled: false, eraserSize: 40 });
  const actions = useActions();

  const handleEnabledChange = useStableCallback((enabled: boolean) => {
    actions.updateSettings({ fogOfWar: { ...fogSettings, enabled } });
  });

  const handleSizeChange = useStableCallback((size: number) => {
    actions.updateSettings({ fogOfWar: { ...fogSettings, eraserSize: size } });
  });

  return (
    <FogOfWarSettings
      enabled={fogSettings.enabled}
      eraserSize={fogSettings.eraserSize}
      onEnabledChange={handleEnabledChange}
      onSizeChange={handleSizeChange}
    />
  );
}

export default FogOfWarSettingsContainer;
